import { flattenCommitFiles } from "../../shared/commitFileRows";
import type { QueryRowType } from "@rocicorp/zero";
import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";

export type CommitFileData = NonNullable<
  QueryRowType<ReturnType<typeof queries.loadCommitFileTree>>
>["files"][number];

// A stable empty array keeps consumers' derived values from recomputing while
// the commit loads.
const NO_FILES: readonly CommitFileData[] = [];

export function useCommitFiles(
  commitId: string,
  options?: Parameters<typeof useQuery>[1]
) {
  const [commit, details] = useQuery(
    queries.loadCommitFileTree({ commitId }),
    options
  );
  return [
    commit?.files ? flattenCommitFiles(commit) : NO_FILES,
    details,
  ] as const;
}
